import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackAssetModalCommentPanelOpen = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetModalCommentPanelOpen = useCallback(() => {
    track(`Opened asset modal comment panel`);
  }, [track]);

  return { trackAssetModalCommentPanelOpen };
};
